import axios from 'axios';
import { supabase } from '../lib/supabase';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:9000'}/api`,
  timeout: 300000, // 5 min — upload + synchronous PDF processing on Vercel (300s max)
});

// Attach the current Supabase JWT to every request.
api.interceptors.request.use(async (config) => {
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.access_token) {
    config.headers['Authorization'] = `Bearer ${session.access_token}`;
  }
  return config;
});

// 401 — token expired: refresh once, then retry.
// Never redirect to /login (that page is removed in demo mode).
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const { data: { session } } = await supabase.auth.refreshSession();
        if (session?.access_token) {
          original.headers['Authorization'] = `Bearer ${session.access_token}`;
          return api(original);
        }
      } catch {
        // Refresh failed — fall through and reject normally.
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export const downloadFile = async (url, filename) => {
  const { data: { session } } = await supabase.auth.getSession();
  const headers = session?.access_token
    ? { Authorization: `Bearer ${session.access_token}` }
    : {};

  const res = await fetch(
    `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:9000'}${url}`,
    { headers }
  );
  if (!res.ok) throw new Error(`HTTP ${res.status}`);

  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(blobUrl);
};
